import script from "./g-header.vue?vue&type=script&setup=true&lang=js"
export * from "./g-header.vue?vue&type=script&setup=true&lang=js"

import "./g-header.vue?vue&type=style&index=0&id=02e23c3c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/theone-chain-explorer-frontend_KUia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e23c3c"]])

export default __exports__